import React from "react";

import { Link } from "react-router-dom";
import HowItWorks from "../components/HowItWorks";
import "./LandingPage.css";

import OffsetProject from "../components/OffsetProject";
import EventCarbon from "../components/EventCarbon";
import YpoCarbonBanner from "../components/YpoCarbonBanner";

const LandingPage = () => {
  return (
    <>
      <section className="hero text-white py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="display-5 fw-bold">
                YPO CARBON CALCULATOR — FLY CARBON NEUTRAL
              </h1>
              <p
                className="lead"
                style={{
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                Quickly calculate your flight emissions and offset them via
                sustainable projects.
              </p>
              <Link to="/calculator" className="carbon-btn mt-3">
                Calculate emissions
              </Link>
            </div>
            <div className="col-md-5 d-none d-md-block">
            </div>
          </div>
        </div>
      </section>

      <HowItWorks />

      <div className="bg-container">
        <div className="text-box text-center">
          <h4
            style={{
              fontWeight: "bold",
              fontFamily: "Oswald, sans-serif",
            }}
          >
            Why offset your carbon?
          </h4>
          <p>
            Offsetting funds projects that reduce greenhouse gases and bring
            community benefits.
          </p>
          <Link
            to="/calculator"
            className="btn btn-outline-light mt-3"
            style={{ fontFamily: "Oswald, sans-serif" }}
          >
            Start calculator
          </Link>
        </div>
      </div>

      <OffsetProject />
      <EventCarbon />
      <YpoCarbonBanner />
    </>
  );
};

export default LandingPage;
